module.exports = __webpack_public_path__ + "img/4-black.225228ef.png";